$( document ).ready(function() {
  var newValue = $("#thetotal").text().replace('$', '');

  var moneynum = parseInt(newValue);
  
  checkmonies();
  
  	$( ".ajax-submit" ).click(function() {
  	
      pollVisibility();
      
	});
  
  	
  //$(document).on('change', '.quantity', function() {
  $('.quantity').change(function() {
   
   $(".checkprice").css("display","none");
 //setTimeout(checkmonies, 2200);
     
	});
  
  //$('#thecart').on('change', function() {
   // alert("change");
 // checkmonies();
//});
  
  	
  
  function pollPricechange() {
		
  		if (tnum != moneynum) {
         alert('yes');
          // call a function here, or do whatever now that the div is not visible
          checkmonies();
      } else {
        
         alert('no');
        setTimeout(pollPricechange, 500);
      }  
  }
  
  
  	function pollVisibility() {
      if ($(".cart_content").is(":visible")) {
          // call a function here, or do whatever now that the div is not visible
          checkmonies();
      } else {
          setTimeout(pollVisibility, 500);
      }
  	}

  
  	
	function checkmonies() {
      	
        var newValue = $("#thetotal").text().replace('$', '');
		var moneynum = parseInt(newValue);
  
  //alert(moneynum);
  		if(moneynum < 149 ){
  			//alert(moneynum);
  			$(".checkprice").css("display","block");
  			$(".needmore").css("display","block");
    		$(".qualified").css("display","none");
    
    		var newmoneynum = 149 - moneynum; 
    		$(".addamount").text(newmoneynum);
  		}
      else {
        $(".checkprice").css("display","block");
  			$(".needmore").css("display","none");
    		$(".qualified").css("display","block");
      }
     
     
   		}
  
});
